import { Component, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { FooterComponent } from '../footer/footer.component';
import { TranslateModule } from '@ngx-translate/core';
import { PaymentStore } from './payment.store';
import { TwoDigitDecimalPriceDirective } from '../../../shared/Directives/appTwoDigitDecimalPrice.directive';
import { ErrorComponent } from '../error/error.component';
import { LoadingSpinnerComponent } from '../loading-spinner/loading-spinner.component';
import { PaymentParamsDto } from '../../Models/PaymentParamsDto';

@Component({
  selector: 'debtor-panel-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss'],
  imports: [
    CommonModule,
    MatCardModule,
    MatInputModule,
    MatButtonModule,
    FormsModule,
    FooterComponent,
    TranslateModule,
    TwoDigitDecimalPriceDirective,
    ErrorComponent,
    LoadingSpinnerComponent,
  ],
})

export class PaymentComponent implements OnInit, OnDestroy {
  protected readonly store = inject(PaymentStore);
  protected validationError = signal<boolean>(false);
  private caseHashId = signal<string>('');

  public ngOnInit(): void {
    const state = history.state;
    if (state && state.paymentParams) {
      const paymentParams = state.paymentParams as PaymentParamsDto;
      if(!paymentParams.caseHashId) {
        this.store.navigateToDashboard();
      }
      this.caseHashId.set(paymentParams.caseHashId);
      this.store.loadData(paymentParams);
    } else {
      this.store.navigateToDashboard();
    }
  }

  public ngOnDestroy(): void {
    history.pushState(null, '', window.location.href);
  }

  protected goToPayment(): void {
    if (this.isValid()) {
      this.validationError.set(false);
      this.store.getPaymentLink({ caseIdHash: this.store.caseDto().caseIdHash, paymentAmount: this.store.amountToPay() });
    } else {
      this.validationError.set(true);
    }
  }

  protected isValid(): boolean {
    return this.store.amountToPay() >= this.store.minAmountForPayment() && this.store.amountToPay() <= this.store.maxAmountForPayment();
  }

  protected checkValidation($event: string): void {
    this.store.setAmountToPay(Number($event.replace(',', '.')));
  }

  protected navigateToOrderContact(): void {
    this.store.navigateToOrderContact();
  }

  protected handleReload(): void {
    this.ngOnInit();
  }

  protected cancel() {
    this.store.navigateToCaseDetails(this.caseHashId());
  }
}
